var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("print-browse")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("filename") },
                    model: {
                      value: _vm.fileName,
                      callback: function ($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.hasExportModule
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-radio", {
                        attrs: {
                          name: "output-type",
                          checked: _vm.outputType == "pdf",
                          label: _vm.$ct("print-to-printer"),
                        },
                        on: {
                          input: function ($event) {
                            _vm.outputType = "pdf"
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-radio", {
                        attrs: {
                          name: "output-type",
                          checked: _vm.outputType == "xlsx",
                          label: _vm.$ct("export-to-excel"),
                          disabled: !_vm.hasExportModule,
                        },
                        on: {
                          input: function ($event) {
                            _vm.outputType = "xlsx"
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-radio", {
                        attrs: {
                          name: "output-type",
                          checked: _vm.outputType == "csv",
                          label: _vm.$ct("export-to-csv"),
                          disabled: !_vm.hasExportModule,
                        },
                        on: {
                          input: function ($event) {
                            _vm.outputType = "csv"
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-transition-slide-height",
            [
              _vm.outputType == "csv" && _vm.isProductView
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("use-csv-import-column-names"),
                        },
                        model: {
                          value: _vm.replaceColumnNamesWithProductCsvNames,
                          callback: function ($$v) {
                            _vm.replaceColumnNamesWithProductCsvNames = $$v
                          },
                          expression: "replaceColumnNamesWithProductCsvNames",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.outputType == "csv" && _vm.isContactView
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          label: _vm.$ct("use-csv-import-column-names"),
                        },
                        model: {
                          value: _vm.replaceColumnNamesWithContactCsvNames,
                          callback: function ($$v) {
                            _vm.replaceColumnNamesWithContactCsvNames = $$v
                          },
                          expression: "replaceColumnNamesWithContactCsvNames",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            [
              _vm.outputType == "pdf"
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { fancy: "", label: _vm.$ct("title") },
                            model: {
                              value: _vm.title,
                              callback: function ($$v) {
                                _vm.title = $$v
                              },
                              expression: "title",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-page-settings-default", {
                            model: {
                              value: _vm.pageSettings,
                              callback: function ($$v) {
                                _vm.pageSettings = $$v
                              },
                              expression: "pageSettings",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }